module.exports = __webpack_public_path__ + "static/media/mixcloud.bf0c0104.png";